module.exports = __webpack_public_path__ + "ansible-11aca10f5b1da62baef9720ac300ad56.svg";